module.exports = __webpack_public_path__ + "img/tooth-movedleft.38c919b1.png";